/**
 * @enum {string}
 */
export var Config;
(function (Config) {
    Config["AUTH_CONFIG"] = "AUTH_CONFIG";
    Config["SERVER_CONFIG"] = "SERVER_CONFIG";
    Config["CONTENT_CONFIG"] = "CONTENT_CONFIG";
    Config["STATIC_CONTENT_CONFIG"] = "STATIC_CONTENT_CONFIG";
})(Config || (Config = {}));
